import ReactSidebar from '@/components/common/ReactSidebar'
import Srcset from '@/components/common/Srcset'
import React, { useEffect, useState } from 'react'
import CustomClearRefinements from '../CustomClearRefinements';
import CustomRefinementList from '../CustomRefinementList';
import styles from "../PlpFilter/plpFilter.module.scss"
import PLPSelectedFiltersComp from '../PLPSelectedFiltersComp/index';
import TotalCount from '../TotalCount';
import { attributeTitles } from '../filters-utils';
import { DynamicWidgets } from 'react-instantsearch';
import { useSelector } from "react-redux";

function PLPFilter({ serverRender, initialRefinement, serverPath, indexName, seoData }) {
  // list of attributes
  let attributes;
  // Create an updated attributeTitles object with the custom attribute
  const updatedAttributeTitles = {
    ...attributeTitles,
    "named_tags.Availability": "Availability",
  };
  // Find the index of "named_tags.categories.lvl2"
  const index = Object.keys(updatedAttributeTitles).indexOf("named_tags.categories.lvl2");

  if (index !== -1) {
    // Split the attributeTitles object into two parts
    const category = Object.fromEntries(Object.entries(updatedAttributeTitles).slice(0, index + 1));
    const restCategories= Object.fromEntries(Object.entries(updatedAttributeTitles).slice(index + 1));

    // Combine them with the custom attribute in between
    const combinedAttributeTitles = { ...category, ...restCategories };

    // Use the combined attributeTitles object to get the attributes
    attributes = Object.keys(combinedAttributeTitles);
  } 
  else {
    // Fallback to using the original attributes from attributeTitles
  attributes = Object.keys(attributeTitles);
  }

  const url = typeof window != "undefined" && window.location.href;


  //OS-5291 handle the filter hide show on load
  useEffect(() => {
    setTimeout(() => {
      if(url.includes('jewelry-watches') || url.includes('Jewelry')) {
        document.querySelector(".availability-filter")?.classList?.remove("hide_filter");	
        document.querySelector(".material-filter")?.classList?.remove("hide_filter");
        document.querySelector(".personalization-filter")?.classList?.remove("hide_filter");
        
        document.querySelector(".sleeves-filter")?.classList?.add("hide_filter");
        document.querySelector(".heel-filter")?.classList?.add("hide_filter");
      } else if(url.includes('clothing') || url.includes('Clothing')) {
        document.querySelector(".availability-filter")?.classList?.remove("hide_filter");	
        // document.querySelector(".material-filter")?.classList?.remove("hide_filter");	
        document.querySelector(".sleeves-filter")?.classList?.remove("hide_filter");	

        document.querySelector(".personalization-filter")?.classList?.add("hide_filter");
        document.querySelector(".heel-filter")?.classList?.add("hide_filter");
      } else if(url.includes('shoes') || url.includes('Shoes')) {
        document.querySelector(".heel-filter")?.classList?.remove("hide_filter");
        
        document.querySelector(".availability-filter")?.classList?.add("hide_filter");	
        document.querySelector(".material-filter")?.classList?.add("hide_filter");
        document.querySelector(".personalization-filter")?.classList?.add("hide_filter");
        document.querySelector(".sleeves-filter")?.classList?.add("hide_filter");
      } else {
        document.querySelector(".availability-filter")?.classList?.add("hide_filter");	
        document.querySelector(".material-filter")?.classList?.add("hide_filter");
        document.querySelector(".personalization-filter")?.classList?.add("hide_filter");
        document.querySelector(".sleeves-filter")?.classList?.add("hide_filter");
        document.querySelector(".heel-filter")?.classList?.add("hide_filter");
      }
      }, 1000);
    
  },[url]);

  //  attributes to clear the filter value
  const includedAttributes = [
    "named_tags.Availability",
    "named_tags.categories.lvl1",
    "named_tags.categories.lvl2",
    "meta.color.base_color",
    "price",
    "vendor"
  ]

  const [handleFilterBar, setHandleFilterBar] = useState(false);
  const isPWA = useSelector((state) => state.pwa.is_PWA);
  const isShopMenuOpen = useSelector((state) => state.header.isMenuVisible);
  const isAccountSidebarOpen = useSelector((state) => state.loginUser.open_account_sidebar);

  //  function for filter module
  const FilterMainContent = () => {
    return (<>
      <div className={`filter_wrapper ${styles.filter_wrap}`}>
        <div className={`${styles.filter_head}`}>
          <div className={`${styles.filter_head_title} x-large-xs xx-large-md xx-large-sm light`}>
            <Srcset
              height=""
              width=""
              src={"images/Icons/Filter.svg"}
              title="Filter Icon"
              alt="Filter Icon"
              loading="lazy"
              requirePath={true}
              svgFile={true}
            />
            Filter
          </div>
          {/* total count of items */}
          <TotalCount />
        </div>
        <div className={styles.filter_body}>
          {/* display all the items having different attributes */}
          {attributes.map((attribute,index) => (
            <>
              {attribute === "named_tags.Material" || attribute === "meta.custom.us_size" ? (
                <DynamicWidgets>
                  <CustomRefinementList serverRender={serverRender} key={index} attribute={attribute} initialRefinement={initialRefinement} serverPath={serverPath} indexName={indexName} limit={attribute === "meta.custom.us_size" ? 250 : 20} />
                </DynamicWidgets>
              ) : (

              <CustomRefinementList serverRender={serverRender} key={index} attribute={attribute} sortBy={["name:asc"]} initialRefinement={initialRefinement} serverPath={serverPath} indexName={indexName} />
              )}
            </>
          ))}
        </div>
        {/* for clearing filters */}
        {!serverRender && <div className={`${styles.filter_foot} ${isPWA?styles.filter_foot_pwa:""}`}>
          <CustomClearRefinements attribute={includedAttributes} seoData={seoData} />
          <button className="btn-primary" onClick={() => { setHandleFilterBar(!handleFilterBar) }}> View Results</button>
        </div>}
      </div>
    </>
    )
  }

  return (
    <>
      {/* if shop menu or account sidebar is clicked from app then filter sidebar should be hidden */}
        {<div className={`filter-content ${isShopMenuOpen || isAccountSidebarOpen ? "d-none" : ""}`}>
          <ReactSidebar
          mainContent={
            <div className="filter-txt large-md normal-sm small-xs light-md auto-plp-filter">
              <Srcset
                height=""
                width=""
                src={"images/Icons/Filter.svg"}
                title="Filter Icon"
                alt="Filter Icon"
                loading="lazy"
                requirePath={true}
                svgFile={true}
              /> Filter
            </div>
          }
          handleSidebar={(e) => {
            setHandleFilterBar(!handleFilterBar);
          }}
          sidebarOpen={handleFilterBar}
          styles={{
            root: {
              position: "relative",
              height: 25,
              width: 90,
            },
            sidebar: {
              position: "fixed",
              overflow: "auto",
            },
          }}
          // calling function to open filter side bar
          sidebarContent={FilterMainContent()}
          pullRight={false}
          isPlpFilter={true}>
          </ReactSidebar>
        </div>
      }
      {/* Filter data selected */}
      {!serverRender && <PLPSelectedFiltersComp serverRender={serverRender} initialRefinement={initialRefinement} attribute={attributes} seoData={seoData} /> }
    </>
  )
}

export default PLPFilter
